import setMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/setMailboxCalendarConfigurationOperation';
import setMailboxCalendarConfigurationRequest from 'owa-service/lib/factory/setMailboxCalendarConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';

export default function setMailboxCalendarConfiguration(
    options: MailboxCalendarConfiguration
): Promise<OptionsResponseBase> {
    let userConfiguration = getUserConfiguration();

    // when OwaMailboxPolicy has LocalEventsEnabled set to false, we don't provide
    // LocalEventsEnabled and LocalEventsLocation properties in the request.
    // Otherwise the insufficient permissions error is returned.
    if (userConfiguration.PolicySettings && userConfiguration.PolicySettings.LocalEventsEnabled) {
        return setMailboxCalendarConfigurationOperation(
            setMailboxCalendarConfigurationRequest({
                Header: getJsonRequestHeader(),
                Options: options,
            })
        );
    } else {
        const { LocalEventsEnabled, LocalEventsLocation, ...rest } = options;
        return setMailboxCalendarConfigurationOperation(
            setMailboxCalendarConfigurationRequest({
                Header: getJsonRequestHeader(),
                Options: rest,
            })
        );
    }
}
